import { AppConfig } from "../../config";
import axios from "axios";
import { trackPromise } from "react-promise-tracker";

let origin = window.location.origin;

// // Demo 2 Account
// let token =
//   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjM3ZjUwNjdiNmY0OWJiOTdjOTY5YThiZjZjMDA5MWNhIiwidXNlcm5hbWUiOiJkZW1vMiIsIm5hbWUiOiJEZW1vIDIifQ.a3TeUZ4TOq2BmucGChFUDCGQVU4q_5_LJFYJGcUmZksrMNfzIzlksBrO18LYfnU_5cmuHQ5kvA9-3WxEyUcJHXGL63mwtKp7uAYv9hlyLWYO-mqCdheBE8mYdWue8TQqwjkXMQ6skqKpmThhGZ2bnXDU4KIZM_PKVk7OvMWJdLTmxv8qGHEml1Fy_0pqZsDSEgc213HNjVOi1HNs-Xr-XzMf1YGEBImBY4VXiqEwZH7WjNFin7PJqyhm9KkW5jptQFYWOYlLqM6HPQVaLOI2SVsVN0KgIGFsbpwKdVlgt6QT1ASeDTpCGqdKxi-J7FFvTFDuAWPVq0jb4c1Z7H0nLQ";

// // Nirmal Bro Account
// let token =
//   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjE3Y2RjMDQxOTQ1YThhNzUzN2M5MmE4MzI4MmU1ODMxIiwidXNlcm5hbWUiOiJuaXJtYWxkdXJhaSIsIm5hbWUiOiJOaXJtYWwgRHVyYWkgWSJ9.b0ETAie9EkkXyx7CsI77oy_0OyiunwsVf6ziS4v3FSb2lzHQmbAW5af5rKl0dSwdW18RLs6mR0qf7BqJknCs4Gt0PI5dcPipr7kLb8RXGRjdmi4id3S6WTscXp5k2uHyQSFxZbb9xUDqnesqtDSTVEV-Oi8lxPusHzA4dnaQeiHamtDICJ4LRsrFTSHLtXos9tfrb_QwrsMilp5yOLFfgKa4VXRPC735y8fgTYCGSD4PUvKPPQ_Cl8PiXcV1K2awVuJahoFBYAuR2EhbX8r-BE8jqVEHZQi-KgLcSiIlAbrYw4aICljrxNMy3EKT7JHDXBK6eskKwmOkhHNfg53WQw";

// //Govind Account
let token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ0b2tlbiI6IjA1YWQ5MDZmNGZkNjAzNDZhMTJjNzU1MzY0ZmNlOTU1IiwidXNlcm5hbWUiOiJHb3ZpbmRhcmFqIiwibmFtZSI6IkdvdmluZGFyYWoifQ.PoTKoSpuntw6CnbswgZy_zkqV2-KZXJb3LjOvIWJlNGMmDWiczDKNBIZn_cXaUBOsN-kJTseiGDwA243URuFsbFGtygSbaZjre68ibjJKDrWBCQp6SwWnoZCzYdCFoAQozC4goqX-6sbnhIQ-08TZfk2Z5kHVkzyr5iLRiuSSP-dOuU_BlJtnRj3mSFeLgtxbD3i9drQzbO5qzJu2eFvhRntS5MWxiMgijGberMM_iGLBHAej2qJXEE37l1ioZ2pBaaeLz63OkN8mq64a5xHFhmMZbOcKckMMCFKGG7tA71dnQ7GBIVCmx19d5qpuexc3nrztU_4fxBw4NoY6Tp1Yw";

if (origin == "http://localhost:19006") {
  origin = "https://postproduction.1superapp.com";
}

export async function api(
  url,
  pass_data = {},
  blob_value = false,
  image = false
) {
  let request_method = "GET";
  let formData;

  if (pass_data.hasOwnProperty("get")) {
    url = url + append_url(pass_data.get);
  }
  if (pass_data.hasOwnProperty("post")) {
    request_method = "POST";
    formData = append_data(pass_data.post, image);
  }

  // 1id=; location=Alampalayam, Tamil Nadu, India; locationtime=1628062197; lt=11.3836032; ln=77.7715712; _ga_ZQQRQQ9BE5=GS1.1.1631787864.13.0.1631787871.0; _gid=GA1.2.1193715456.1642404178; _ga_B03KHMKBKM=GS1.1.1642410655.59.0.1642410655.0; _ga=GA1.2.763220466.1620112169; 1id_web=0489b11aac69f9ac726534956c894bea339923f7; _gat_gtag_UA_212833236_1=1

  let option = {
    // withCredentials: true,
    method: request_method,
    url: AppConfig.base_url.api + url,
    // headers: { "1id": token },
  };

  if (blob_value) {
    option.responseType = "blob";
  }

  if (formData) {
    option.data = formData;
  }

  const dataPromise = await trackPromise(
    // axios(option, { headers: { Authorization: "Bearer " + token } })
    axios(option)
      .then((res) => {
        let res_pass = {
          status: true,
          status_code: res.status,
          status_text: res.statusText,
          response: res.data,
        };
        return res_pass;
      })
      .catch((err) => {
        let res_pass = {
          status: false,
          // status_code: err.response.status,
          // status_text: err.response.statusText,
          response: error_handler(err),
          // response: "error",
        };
        return res_pass;
      })
  );

  return dataPromise;
}

function append_url(data) {
  let pass_string = "";
  Object.entries(data).forEach(([key, value], index) => {
    if (index == 0) {
      let join_data = "?" + key + "=" + value;
      pass_string = pass_string + join_data;
    } else {
      let join_data = "&" + key + "=" + value;
      pass_string = pass_string + join_data;
    }
  });
  return pass_string;
}

function append_data(data, image) {
  const postdata = new FormData();
  for (const items in data) {
    if (image) {
      postdata.append(items, data[items]);
    } else {
      if (data[items].isArray || isObject(data[items])) {
        postdata.append(items, JSON.stringify(data[items]));
      } else {
        postdata.append(items, data[items]);
      }
    }
  }
  return postdata;
}

function isObject(data) {
  return data instanceof Object;
}

function error_handler(error) {
  // if (error.request) {
  //   console.log("error.request", error.request);
  // }
  // if (error.response) {
  //   console.log("error.response.data", error.response.data);
  //   console.log("error.response.status", error.response.status);
  //   console.log("error.response.headers", error.response.headers);
  // }
  // if (error.message) {
  //   console.log("error.message", error.message);
  // }
  // console.log("error.config", error.config);

  if (error.response == undefined) {
    // console.log("Network Error");
    return "Network Error";
  } else if (error.response.status === 401) {
    console.log("Unauthorized Error");
    // return "Unauthorized Error";
    window.location = origin + "/app/login?r=" + window.location.href;
  }
}
